var _rect, _path, _path2, _path3, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow44(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4629 17.2358H19.218C17.9936 17.2358 17 18.1996 17 19.3681V38.7119C17 39.8889 18.0025 40.8442 19.218 40.8442H31.2393C31.1062 35.0956 33.1467 23.9396 37.4673 17.2188L37.4629 17.2358Z",
    fill: "#0F80CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8008 17.8613H19.2212C18.8039 17.8625 18.4041 18.0223 18.109 18.306C17.8139 18.5897 17.6477 18.9741 17.6465 19.3752V37.3075C21.6299 35.8363 27.6051 34.5697 31.7394 34.6294C33.0139 28.932 34.7023 23.3286 36.8008 17.8613Z",
    fill: "url(#paint0_linear_1188_25708)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7253 16.6048C40.4743 15.5386 38.9617 15.9651 37.4668 17.2359L36.8014 17.8585C34.2463 20.4599 31.9219 25.2873 31.1412 28.9761C31.4193 29.5603 31.6392 30.1686 31.7977 30.7928L31.8953 31.2192L31.9929 31.6542C31.9929 31.6542 31.9707 31.5689 31.8775 31.3131L31.8154 31.1425C31.803 31.1109 31.7897 31.0796 31.7755 31.0487C31.5211 30.5373 31.2444 30.0365 30.946 29.5476C30.7846 30.001 30.6323 30.4574 30.4891 30.9165C31.0746 31.9485 31.4295 33.714 31.4295 33.714C31.4295 33.714 31.3985 33.5988 31.2521 33.2022C31.119 32.8483 30.4713 31.7523 30.3205 31.4964C30.0544 32.4346 29.9523 33.0658 30.0455 33.2193C30.2229 33.5178 30.4004 34.0722 30.5556 34.601C30.7952 35.5388 30.9906 36.4865 31.1412 37.4412L31.1634 37.7056C31.1174 38.772 31.1396 39.8401 31.2299 40.904C31.3452 42.2388 31.5626 43.3859 31.8376 44L32.0239 43.9019C31.6247 42.6908 31.4561 41.1087 31.5271 39.2792C31.638 36.4859 32.3034 33.117 33.541 29.6073C35.6392 24.2638 38.5314 20.0078 41.1841 17.9779C38.7665 20.0761 35.4972 26.8652 34.5213 29.377C33.4257 32.1916 32.6494 34.8356 32.1792 37.3644C32.9865 34.9933 35.5948 33.9699 35.5948 33.9699C35.5948 33.9699 36.8812 32.4517 38.3717 30.2811L35.5106 31.0146L34.5879 31.4069C34.5879 31.4069 36.9389 30.0294 38.9661 29.4026C41.7475 25.1935 44.7772 19.2104 41.7253 16.6005",
    fill: "#0A6894"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1188_25708",
    x1: 28.6964,
    y1: 18.2579,
    x2: 28.6964,
    y2: 36.2286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97D9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92024,
    stopColor: "#0F80CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F80CC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow44);
export default __webpack_public_path__ + "static/media/row-4-4.b82ae24cf630e319c00ecf53f44a4e3e.svg";
export { ForwardRef as ReactComponent };